var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-customer'),_c('about-customer'),_c('promo-customer'),_c('blog-customer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }